import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Field } from '@k2/common/k2-forms-state/types';
import { mergeDeepRight } from 'ramda';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'locality-fields',
    templateUrl: 'locality-fields.component.html',
    standalone: false
})
export class LocalityFieldsComponent implements OnChanges {
  @Input() regionField: Field;
  @Input('locationField') _locationField: Field;

  isRegionRestricted: Observable<boolean>;
  locationField: Observable<Field>;

  ngOnChanges(changes: SimpleChanges): void {
    const regionControl = this.regionField.control;
    const regionChanges = regionControl.valueChanges.pipe(startWith(regionControl.value));

    this.isRegionRestricted = regionChanges.pipe(
      map(regionId => {
        if (regionId == null) return false;

        const region = this.regionField.attributes.valueOptions.find(({ id }) => id === regionId);
        return region.is_restricted;
      })
    );

    this.locationField = regionChanges.pipe(map(toFieldWithRegion(this._locationField)));
  }
}

function toFieldWithRegion(field: Field) {
  return (regionId: number): Field =>
    mergeDeepRight(field, {
      attributes: { region_id: regionId }
    });
}
